import SaleOrderModal from 'components/SaleOrders/sale-order-modal/SaleOrderModal';
import { SaleOrdersSearchBar } from 'components/SaleOrders/SaleOrdersSearchBar';
import { SaleOrdersTable } from 'components/SaleOrders/SaleOrdersTable';
import { SaleOrder } from 'models/sale-order';
import React, { PureComponent } from 'react';
import { AuthenticationContext } from 'services/context/authentication.context';
import SaleOrderService from 'services/sale-order.service';


export class SaleOrders extends PureComponent<any, any> {

  static contextType = AuthenticationContext;

  constructor(props: any) {
    super(props);
    props.onLoadValidatePage();

    this.state = {
      customerId: null,
      status: null,
      selectedLocation: null,
      isOrderModalVisible: false,
      selectedOrder: null,
      type: null,
      orders: [],
      loading: false
    };
  }

  updateCustomerId = () => {
    if (this.context.state.customerId !== this.state.customerId) {
      this.setState({
          ...this.state,
          customerId: this.context.state.customerId
      }, () => {
          this.getOrders();
      });
    }
  };

  componentDidMount(): void {
    this.updateCustomerId();
  }

  componentDidUpdate(): void {
    this.updateCustomerId();
  }

  getOrders(): void {
    if (this.state.customerId) {
      this.setState({ loading: true });
      SaleOrderService.getOrders(this.state.customerId).then((res) =>
        this.setState({ orders: res, loading: false })
      ).catch(err => {
        console.error(err);
        this.setState({ orders: [], loading: false });
      });
    }
  }
  render() {
    const uniqueLocations = Array.from<string>(new Set(this.state.orders.map((o: SaleOrder) => o.location?.address ?? '-')));

    return (
      <div className="agreements__container">
        <SaleOrdersSearchBar 
          status={this.state.status}
          onStatusChange={(status) => this.setState({ status })}
          locations={uniqueLocations}
          selectedLocation={this.state.selectedLocation}
          onLocationChange={(address) => this.setState({ selectedLocation: address })}
          onQuoteClick={() => this.setState({ isOrderModalVisible: true, type: 'QUOTE', selectedOrder: null })}
          onOrderClick={() => this.setState({ isOrderModalVisible: true, type: 'ORDER', selectedOrder: null })}
        />
        <SaleOrdersTable
          orders={ this.state.orders }
          isRequesting={ this.state.loading }
          statusFilter={ this.state.status }
          locationFilter={ this.state.selectedLocation }
          onOrderSelected={(order: SaleOrder) => this.setState({
            isOrderModalVisible: true,
            selectedOrder: order,
            type: order.isQuote ? 'QUOTE' : 'ORDER'
          })}
        />  
        {
          this.state.isOrderModalVisible &&
          <SaleOrderModal
            type={this.state.type}
            isNew={!this.state.selectedOrder}
            order={this.state.selectedOrder}
            handleModalHide={() => this.setState({ isOrderModalVisible: false, type: null, selectedOrder: null })}
            onSubmitSuccess={() => {
              this.setState({ isOrderModalVisible: false, type: null, selectedOrder: null });
              this.getOrders();
            }}
          />          
        }
     </div>);
  }
}